// Ajax helpers that show the spinner while loading.

global.overrides = {
  spinnerAjax: function($holder, url, settings) {
    $holder.find('.ball-spinner').show();
    settings = settings || {};
    settings.complete = function() { $holder.find('.ball-spinner').hide(); };
    $.ajax(url, settings);
  }
};
